import React from "react";
import PropTypes from "prop-types";
import { Button } from "@sainsburys-tech/fable";
import DeviceFilterListItem from "./DeviceFilterListItem";

const DeviceFilter = props => (
  <div>
    <h4>Filter devices</h4>
    <ul style={{ display: 'block', listStyle: 'none', padding: 0, margin: '0 0 24px 0' }}>
      {props.tagHierarchy["submeter-category"].map((category, index) => (
        <DeviceFilterListItem
          key={index}
          category={category}
          submeterCategory={props.submeterCategory}
          submeterPurpose={props.submeterPurpose}
          submeterSubpurpose={props.submeterSubpurpose}
          handleFilterUpdated={props.handleFilterUpdated}
        />
      ))}
    </ul>
    <span>
      <Button
        variant="tertiary"
        onClick={() =>
          props.handleFilterUpdated({
            category: null,
            purpose: null,
            subpurpose: null
          })
        }
      >
        Clear all filters
      </Button>
    </span>
  </div>
);

DeviceFilter.propTypes = {
  tagHierarchy: PropTypes.shape({
    "submeter-category": PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        "submeter-purpose": PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
            "submeter-sub-purpose": PropTypes.arrayOf(
              PropTypes.shape({
                name: PropTypes.string
              })
            )
          })
        )
      })
    )
  }),
  handleFilterUpdated: PropTypes.func
};

export default DeviceFilter;
